import * as React from 'react';

function CircleCloseIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 21 21" fill="none" {...props}>
			<path
				d="M10.49.25c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm4.02 6.313a.5.5 0 00-.706 0L10.49 9.876 7.177 6.563a.5.5 0 00-.707.708l3.312 3.312-3.312 3.313a.5.5 0 00.707.707l3.313-3.313 3.314 3.314a.5.5 0 00.707-.707l-3.314-3.314 3.314-3.312a.5.5 0 000-.708z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default CircleCloseIcon;
